import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List, Map } from "immutable";
import numeral from "numeral";
import moment from "moment";
import Auth from '../../../lib/auth';

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import Select from "../../../components/common/virtualized-select";
import Loading from '../../../components/common/Loading';

// Actions
import { getYears, cleanYears } from '../../../actions/years';
import { getReceipts, cleanReceipts } from "../../../actions/receipts";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'receipt_code delivery_date orders supplier_receipt_code supplier statistics.subtotal statistics.vat statistics.total',
    populateRefs: [{
        field: 'supplier',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'receipts'
};

class ReceiptsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedYear: Auth.getSelectedYear(),
            receiptsIsFetching: false
        };
    }
    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getReceipts(queryOptions);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getReceipts(queryOptions);
        }
    }
    componentWillUnmount() {
        this.props.cleanReceipts();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            delivery_date: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        // Stats Zone
        let totalReceipts = 0;
        const receiptsIsFetching = this.props.receiptsIsFetching;

        this.props.receipts.forEach(receipt => totalReceipts = totalReceipts + receipt.getIn(['statistics', 'total']));

        // Receipts Table
        let tableData = this.props.receipts;
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            receipt_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'receipt_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/albaranes/' + value[0] }>{ value[1] }</Link>
                }
            },
            delivery_date: {
                title: "Fecha de entrega",
                columnType: 'date',
                dataField: 'delivery_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            orders: {
                title: "Pedidos Relacionados",
                columnType: 'function',
                dataField: 'orders',
                width: 300,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let orders = [];

                    value.forEach((order, index) => {
                        index === 0
                            ? orders.push(<Link to={ '/compras/pedidos/' + order._id }>{ order.order_code }</Link>)
                            : orders.push([<span>,&nbsp;</span>, <Link to={ '/compras/pedidos/' + order._id }>{ order.order_code }</Link>])
                    });

                    return (
                        <div className="d-flex">
                            {orders}
                        </div>
                    );
                }
            },
            supplier_receipt_code: {
                title: "Código de albarán del proveedor",
                columnType: 'text',
                dataField: 'supplier_receipt_code',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 300,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                        <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/albaranes/' + value)} />
                    </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Albaranes</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/compras/albaranes/nuevo') } > <Icon icon="insert"/>Albaran</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.receipts.size || 0 }</span>
                            <span>Albaranes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalReceipts).format() }</span>
                            <span>Total albaranes</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    {receiptsIsFetching ? (
                                        <Loading show={receiptsIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const receiptsReducer = state.receipts;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // Receipts
    let receipts = receiptsReducer.get('payload') || List([]);
    const receiptsIsFetching = receiptsReducer.get('isFetching');

    if (!(receipts instanceof List)) {
        receipts = List([])
    }

    return {
        years,
        receipts,
        receiptsIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getReceipts: (query) => dispatch(getReceipts(query)),
        cleanYears: () => dispatch(cleanYears()),
        cleanReceipts: () => dispatch(cleanReceipts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptsPage);


// WEBPACK FOOTER //
// ./src/containers/purchases/receipts/ReceiptsPage.js